export const RECAPTCHA_URL = 'https://www.google.com/recaptcha/api.js';
export const QUERY_STRING = '?render=explicit';
export const WIDGET_ID = 'g-recaptcha';

export const PRE_PROD_SITE_KEY = '6LdT7-YUAAAAALhRqvtD72QGgEdQK4k32ADgiXRo';
export const PROD_SITE_KEY = '6LdH7-YUAAAAAIleGtcD_-QpFBD251hFEJ2lrQMW';

/**
 * These locale codes map directly to the locale codes expected/used here at Clover, but
 *  we only want a small subset of these for mapping to equivalent google recaptcha locale codes
 */
export type RecaptchaLocale = 'es-AR' | 'de-DE' | 'en-CA' | 'fr-CA' | 'en-US' | 'en-GB' | 'de-AT' | 'nl-NL';

/**
 * These are the locale codes used and consumed by the google recaptcha component (i.e. they're specified by Google, not us)
 */
export type RecaptchaLocaleCode = 'es-419' | // latin-american spanish
  'de' |      // german
  'de-AT' |   // austrian german
  'en' |      // english
  'en-GB' |   // british english
  'fr-CA' |   // canadian french
  'nl';       // netherlands (dutch)

// take Clover locale code and map to equivalent Google-accepted locale code
export const RECAPTCHA_LOCALE_MAP: Record<RecaptchaLocale, RecaptchaLocaleCode> = {
  'es-AR': 'es-419',
  'de-DE': 'de',
  'de-AT': 'de-AT',
  'en-US': 'en',
  'en-GB': 'en-GB',
  'en-CA': 'en',
  'fr-CA': 'fr-CA',
  'nl-NL': 'nl',
};

export const convertToRecaptchaLocale = (browserLocale: RecaptchaLocale): RecaptchaLocaleCode => {
  const recaptchaCode = RECAPTCHA_LOCALE_MAP[browserLocale];

  if (!recaptchaCode) console.error('Unable to initialize locale from browser'); // log if somehow locale not found in map

  return recaptchaCode ?? 'en'; // fallback to default recaptcha locale code equivalent to en-US
};

export const RECAPTCHA_TITLE = 'recaptcha challenge';
export const WIDGET_TEST_ID = 'recaptcha-widget';
